import React from 'react';

import { JobDetailContext } from '@/contexts';
import { LO_APPLICATION_SUBMITTED_STORAGE_PREFIX } from '@/domain/job-application';
import { Actions } from '@/domain/job-details/components/header/components/actions/actions-component';
import { JobFeatures, JobUserXingApplicationStatus, VisibleJob, useJobActionsQuery } from '@/graphql/generated';
import { getKey } from '@/helpers/storage';
import { useHasMounted } from '@/hooks';

import addTrackingParams from './addTrackingParams';

type Props = {
  isSticky?: boolean;
};

export const ActionsContainer: React.FC<Props> = ({ isSticky = false }) => {
  const { slug } = React.useContext(JobDetailContext);
  const { loading, error, data } = useJobActionsQuery({ variables: { slug } });
  const hasMounted = useHasMounted();
  const job = (data?.job?.__typename === 'VisibleJob' ? data.job : {}) as VisibleJob;

  if (loading || error) return null;

  const { application, description, features, userInteractions, prioritized } = job;

  const xingApplicationStatus = userInteractions?.application?.status;
  const didUserXingApplyLoggedIn =
    xingApplicationStatus &&
    xingApplicationStatus !== JobUserXingApplicationStatus.Error &&
    xingApplicationStatus !== JobUserXingApplicationStatus.Undelivered;

  const loggedOutSubmissionDate = getKey<{ submittedAt?: string }>(
    `${LO_APPLICATION_SUBMITTED_STORAGE_PREFIX}:${slug}`,
    {}
  ).submittedAt;

  const applyUrl =
    application?.__typename === 'UrlApplication' && application.applyUrl
      ? hasMounted
        ? addTrackingParams(application.applyUrl)
        : application.applyUrl
      : undefined;

  return (
    <Actions
      applicationType={application?.__typename}
      didUserXingApplyLoggedIn={didUserXingApplyLoggedIn}
      didUserXingApplyLoggedOut={!!loggedOutSubmissionDate}
      features={features ?? ({} as JobFeatures)}
      {...(description?.__typename === 'PdfDescription' && { pdfUrl: description.pdfUrl ?? '' })}
      applyUrl={applyUrl}
      isPaidJob={prioritized}
      isSticky={isSticky}
    />
  );
};
